export default __webpack_public_path__ + "ui/assets/img/group-2.svg";